import classNames from "classnames";
import type React from "react";
import { usePreviousLocation } from "../../CapturePreviousLocation";
import "./Overlay.css";
import { Flex } from "./Flex";
import Icon from "./Icon";

type Props = {
    children?: React.ReactNode;
    header?: React.ReactNode;
    footer?: React.ReactNode;
    className?: "dark" | "light";
    extraClassNames?: string[];
    fullsize?: boolean;
    printButton?: boolean;
    previousLocationFallback?: string | undefined;
    onClose?: () => boolean;
};

const Overlay = function Overlay(props: Props) {
    const {
        children,
        header,
        footer,
        className,
        extraClassNames,
        fullsize,
        printButton,
        previousLocationFallback,
        onClose,
    } = props;
    const previousLocation = usePreviousLocation();

    const close = () => {
        if (onClose && !onClose()) return;
        previousLocation.goBack(previousLocationFallback);
    };

    return (
        <div
            className={classNames(
                "overlay",
                className && `overlay--${className}`,
                extraClassNames,
            )}
            onClick={(event) => {
                close();
                event.stopPropagation();
            }}
        >
            <div
                className={classNames("overlay__modal", {
                    "overlay__modal--fullsize": fullsize,
                })}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <div className="overlay__header">
                    <div>{header}</div>
                    {printButton ? (
                        <div className="overlay__header__print">
                            <button
                                type="button"
                                onClick={() => {
                                    window.print();
                                }}
                            >
                                Print
                            </button>
                        </div>
                    ) : null}
                    <button type="button" className="overlay__close" onClick={close}>
                        <Icon.Close.Medium />
                    </button>
                </div>
                <div
                    className={classNames("overlay__scroll", {
                        "overlay__scroll--with-footer": !!footer,
                    })}
                >
                    {children}
                </div>
                {footer && <Flex.Row className="overlay__footer">{footer}</Flex.Row>}
            </div>
        </div>
    );
};

export default Overlay;
